import { server_connection } from 'config';

export const GET_PERMISSIONS_FULL_LIST = '[PERMISSION APP] GET PERMISSIONS FULL LIST';
export const GET_AUTH_ROLE_LIST        = '[PERMISSION APP] GET ROLE LIST';
export const UPDATE_ROLE_PERMISSION    = '[PERMISSION APP] UPDATE ROLE PERMISSION';

export function getPermissions() {
    return (dispatch) => {
        fetch(server_connection + '/permission/full_list')
            .then((response) => response.json())
            .then((permissionFullList) => {
                dispatch({
                    type: GET_PERMISSIONS_FULL_LIST,
                    payload: permissionFullList,
                });
            });
    }
}

export function saveRolePermissions(permissionFullList) {
    return (dispatch) => {
        fetch(server_connection + '/permission/save',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ permissionFullList })
            }).then(() => {
                window.location.reload();
            });
    }
}

export function getAuthRoleList() {
    return (dispatch) => {
        fetch(server_connection + '/auth/auth_roles/list')
            .then((response) => response.json())
            .then((authRoleList) => {
                dispatch({
                    type: GET_AUTH_ROLE_LIST,
                    payload: authRoleList,
                });
            });
    }
}

export function updateRolePermission(permission_id, role_id, status) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_ROLE_PERMISSION,
            payload: { permission_id, role_id, status }
        })
    }
}


// WEBPACK FOOTER //
// src/main/content/permission/store/actions/permission.actions.js